import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import includes from 'lodash/includes';

var LocalizeService =
/*#__PURE__*/
function () {
  function LocalizeService() {
    _classCallCheck(this, LocalizeService);

    this.supportedLanguages = ['en', 'es', 'pt-BR'];
    this.countriesLanguage = {
      argentina: 'es',
      brazil: 'pt-BR',
      mexico: 'es',
      paraguay: 'es',
      peru: 'es',
      uruguay: 'es',
      bolivia: 'es',
      chile: 'es',
      'costa rica': 'es',
      'dominican republic': 'es',
      ecuador: 'es',
      'el salvador': 'es',
      guatemala: 'es',
      honduras: 'es',
      nicaragua: 'es',
      panama: 'es',
      venezuela: 'es'
    };
  }

  _createClass(LocalizeService, [{
    key: "exists",
    value: function exists() {
      return !!window.Localize;
    }
  }, {
    key: "checkIfSupported",
    value: function checkIfSupported(lang) {
      return includes(this.supportedLanguages, lang);
    }
  }, {
    key: "getLanguage",
    value: function getLanguage() {
      return this.exists() && this.checkIfSupported(window.Localize.getLanguage()) && window.Localize.getLanguage() || 'en';
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      this.exists() && window.Localize.setLanguage(lang);

      if (window.drift && window.drift.config) {
        window.drift.config({
          locale: lang
        });
      }
    }
  }, {
    key: "translate",
    value: function translate(input) {
      return this.exists() && window.Localize.translate(input) || input;
    }
  }, {
    key: "getLanguageForCountry",
    value: function getLanguageForCountry(country) {
      return this.countriesLanguage[country] || 'en';
    }
  }]);

  return LocalizeService;
}();

export default new LocalizeService();